module.exports = __webpack_public_path__ + "img/head_bg5.85924062.png";